// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2UDLw","overflowing":"ReadFullNote_overflowing__1n-Wy"};